import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class linksBox {
	static classname = 'links-box';

	constructor($links_box) {
		this.$links_box = $links_box;

		this.bindEvents();
		this.bindGlobalEvents();
	}

	get contained_classname() {
		return this.$links_box.data('contained-classname');
	}

	get with_breadcrumbs_dots() {
		return this.$links_box.hasClass('links-box_with-breadcrumbs-dots');
	}

	bindEvents() {
		if (this.with_breadcrumbs_dots) {
			const $dots = $('.links-box__breadcrumbs-dots');
			$dots.on('click', this.handleClickDots);
		}
	}

	bindGlobalEvents() {
		if (this.with_breadcrumbs_dots) {
			$(document).on('click', this.handleClickDocument);
		}
	}

	handleClickDots = () => {
		const $container = $(`.${this.contained_classname}`);
		$container.toggleClass('js-visible');
	};

	handleClickDocument = e => {
		if ($(e.target).closest(`.${this.contained_classname}`).length === 0 && $(e.target).closest('.links-box__breadcrumbs-dots').length === 0) {
			const $container = $(`.${this.contained_classname}`);
			$container.removeClass('js-visible');
		}
	};
}
